import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Who We Serve", href: "#who-we-serve" },
  { label: "Plans", href: "#plans" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Leadership", href: "#leadership" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-10">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img src="/assets/logo.jpg" alt="Gsoftware logo" className="h-9 w-9 rounded-sm object-cover" />
          <span className="font-display text-sm font-bold tracking-widest text-[#00f0ff] text-glow-cyan">
            GSOFTWARE
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-mono-tech text-xs uppercase tracking-widest text-white/60 transition-colors duration-300 hover:text-[#00f0ff]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#subscribe"
            data-testid="nav-get-started-btn"
            className="glitch-hover border border-[#00f0ff] px-5 py-2 font-mono-tech text-xs font-bold uppercase tracking-widest text-[#00f0ff] transition-shadow duration-300 hover:glow-cyan"
          >
            Get Started
          </a>
        </nav>

        <button
          className="text-white md:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-white/10 bg-black px-6 py-4 md:hidden" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="block py-3 font-mono-tech text-xs uppercase tracking-widest text-white/70 hover:text-[#00f0ff]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-get-started-btn"
            className="mt-2 block border border-[#00f0ff] px-5 py-3 text-center font-mono-tech text-xs font-bold uppercase tracking-widest text-[#00f0ff]"
          >
            Get Started
          </a>
        </nav>
      )}
    </header>
  );
}
